
<template>
  <div class="editor">
    <editor-menu-bubble :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, menu }">
      <div
        class="menububble"
        :class="{ 'is-active': menu.isActive }"
        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
      >
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          {{ $t("elements.rich_text_editor.title") }}
        </button>

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <i class="fe fe-bold" />
        </button>

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <i class="fe fe-italic" />
        </button>

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.code() }"
          @click="commands.code"
        >
          <i class="fe fe-code" />
        </button>

      </div>
    </editor-menu-bubble>
    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { Editor, EditorContent, EditorMenuBubble } from 'tiptap'
    import {
        Blockquote,
        BulletList,
        CodeBlock,
        HardBreak,
        Heading,
        ListItem,
        OrderedList,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
        Placeholder,
    } from 'tiptap-extensions'
    export default {
        components: {
            EditorContent,
            EditorMenuBubble,
        },
        computed: {
            ...mapGetters([
                'window',
                'selected_task',
            ]),
        },
        data() {
            return {
                keepInBounds: true,
                editor: null
            }
        },
        methods: {
            recordContent () {
                this.selected_task.description = this.editor.getHTML();
            }
        },
        watch: {
            selected_task: function () {
                if (this.selected_task) {
                    this.editor.setContent(this.selected_task.description)
                }
            }
        },
        mounted() {
            this.editor = new Editor({
                onUpdate: this.recordContent,
                autoFocus: true,
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({ levels: [1, 2, 3] }),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link(),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new History(),
                    new Placeholder({
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: this.$t('common.edit_task.set_task_description'),
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true,
                    }),
                ],
                content: this.selected_task.description,
            })
        },
        beforeDestroy() {
            this.editor.destroy()
        },
    }
</script>


<style>

  /*.editor {
    position: relative;
    max-width: 30rem;
    margin: 0 auto 5rem auto;
  }
*/

  .is-editor-empty:first-child::before {
    content: attr(data-empty-text);
    float: left;
    color: #6F85A2;
    pointer-events: none;
    height: 0;
    font-style: italic;
  }

  .editor__content {
    cursor: text;
    font-size: 15px;
    font-weight: 500;
    line-height: 17px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
  }
  .editor__content pre {
    padding: 0.7rem 1rem;
    border-radius: 5px;
    background: #000;
    color: #fff;
    text-shadow: 0 0.5px gainsboro;
    font-size: 0.8rem;
    overflow-x: auto;
  }
  .editor__content pre code {
    display: block;
  }
  .editor__content p code {
    display: inline-block;
    padding: 0 0.4rem;
    border-radius: 5px;
    font-size: 0.8rem;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.8);
  }
  .editor__content ul, .editor__content ol {
    padding-left: 1rem;
  }
  .editor__content li > p, .editor__content li > ol, .editor__content li > ul {
    margin: 0;
  }
  .editor__content a {
    color: #2EA763;
    cursor: pointer;

  }
  .editor__content blockquote {
    border-left: 3px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.8);
    padding-left: 0.8rem;
    font-style: italic;
  }
  .editor__content blockquote p {
    margin: 0;
  }
  .editor__content img {
    max-width: 100%;
    border-radius: 3px;
  }
  .editor__content table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;
  }
  .editor__content table td, .editor__content table th {
    min-width: 1em;
    border: 2px solid #eee;
    padding: 3px 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
  }
  .editor__content table td > *, .editor__content table th > * {
    margin-bottom: 0;
  }
  .editor__content table th {
    font-weight: bold;
    text-align: left;
  }
  .editor__content table .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(200, 200, 255, 0.4);
    pointer-events: none;
  }
  .editor__content table .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: 0;
    width: 4px;
    z-index: 20;
    background-color: #adf;
    pointer-events: none;
  }
  .editor__content .tableWrapper {
    margin: 1em 0;
    overflow-x: auto;
  }
  .editor__content .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }


  .menububble {
    position: absolute;
    display: flex;
    z-index: 20;
    background: #000;
    border-radius: 5px;
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
  }
  .menububble.is-active {
    opacity: 1;
    visibility: visible;
  }
  .menububble__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: #fff;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
  }
  .menububble__button:last-child {
    margin-right: 0;
  }
  .menububble__button:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .menububble__button.is-active {
    background-color: rgba(255, 255, 255, 0.2);
  }
  .menububble__form {
    display: flex;
    align-items: center;
  }
  .menububble__input {
    font: inherit;
    border: none;
    background: transparent;
    color: #fff;
  }



</style>
